import { Link } from "react-router-dom";
import { TYPE_META, TYPE_ORDER } from "@/lib/videos";

export default function CategoryEntries() {
  return (
    <section className="px-4 md:px-6 lg:px-8" aria-label="分类快捷入口">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {TYPE_ORDER.map((type) => {
          const meta = TYPE_META[type];
          return (
            <Link
              key={type}
              to={`/category/${type}`}
              className="group flex items-center gap-4 rounded-lg border border-background-200/70 bg-background-50 p-5 transition-colors duration-300 hover:border-primary-300 hover:bg-primary-50"
            >
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${meta.icon} text-2xl`}></i>
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-2">
                  <span className="font-heading text-base font-semibold text-foreground-950">
                    {meta.title}
                  </span>
                  <i className="ri-arrow-right-line text-sm text-foreground-400 transition-transform group-hover:translate-x-1 group-hover:text-primary-500"></i>
                </span>
                <span className="mt-1 block text-xs leading-relaxed text-foreground-600 line-clamp-1">
                  {meta.slogan}
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}